import { ReactNode } from 'react';
import HeaderBackground, { BackgroundVariant } from '@creditflowresearch/uilib/HeaderBackground';
import Flex from '@creditflowresearch/uilib/Flex';
import WithBackground from '@creditflowresearch/uilib/WithBackground';
import type { IFilterButton } from '@/creditflowresearch/ui/common/components/organisms/ButtonGroup';
import { IFilterButtonSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';
import PageTopSectionItems from './PageTopSectionItems';

import styles from './pageTopSection.module.scss';

interface IPageTopSectionProps {
  onClick?: (item: IFilterButton) => void,
  title: string | ReactNode,
  children?: ReactNode,
  items: IFilterButtonSet[] | IFilterButton[] | ReactNode,
  titleDataTest?: string,
  sectionDataTest?: string,
}

const PageTopSection = ({
  onClick,
  title,
  children,
  items,
  titleDataTest = 'pageHeaderTitle',
  sectionDataTest = 'pageTopSection',
}: IPageTopSectionProps) => (
  <WithBackground background={ <HeaderBackground variant={ BackgroundVariant.bottom } /> }>
    { children }
    <Flex
      className={ styles.section }
      direction="row"
      wrap="wrap"
      justify="space-between"
      align="center"
      gap={ 20 }
      data-test={ sectionDataTest }
    >
      <h2 data-test={ titleDataTest } className={ styles.title }>{ title }</h2>
      <Flex align="center" wrap="wrap" gap={ 30 } style={ { marginLeft: 'auto' } }>
        <PageTopSectionItems items={ items } onClick={ onClick } />
      </Flex>
    </Flex>
  </WithBackground>
  );

export default PageTopSection;
